import { UserKeys, getCalendarsForTab } from '../../../../api/users-api';
import { useQuery } from '@tanstack/react-query';
import CalendarGrid from './calendar-grid';
import { useParams } from 'react-router-dom';
import { Messages } from '../../../../utils/message-constants';
import { useUserSettings } from '../../../../utils/use-user-settings';
import ChangeLogDialog from '../../../../shared/change-log-dialog';
import { UserRoles } from '../../../../utils/roles/client-roles';
import { useChangeLogGate } from '../../../../shared/hooks/use-change-log-gate';

export default function CalendarPage() {
  const { userEmail } = useParams() as { userEmail: string };
  const { changeLogRoles, administrationRoles, calendarRoles, primaryDomain } =
    useUserSettings();

  const {
    needsChangeLog,
    canFetch,
    confirmedChangeLogMessage,
    changeLogMessage,
    setChangeLogMessage,
    openChangeLogDialog,
    openDialog,
    confirm,
    dismiss,
  } = useChangeLogGate({
    permissionValue: UserRoles.ViewCalendarsTab.value,
    changeLogRoles,
  });

  const { data, isLoading, isFetching } = useQuery({
    queryKey: [UserKeys.Calendars, userEmail, confirmedChangeLogMessage],
    queryFn: () => getCalendarsForTab(userEmail, confirmedChangeLogMessage),
    enabled: canFetch,
    meta: {
      errorMessage: Messages.Errors.Network.Loading("this user's calendars"),
    },
  });

  const sortedData = [...(data || [])].sort((a, b) => {
    return a.summary.localeCompare(b.summary);
  });

  return (
    <>
      <ChangeLogDialog
        open={openChangeLogDialog}
        handleClose={dismiss}
        changeLogMessage={changeLogMessage}
        setChangeLogMessage={setChangeLogMessage}
        mutate={() => confirm()}
        mutateLoading={false}
      />
      <CalendarGrid
        userEmail={userEmail}
        primaryDomain={primaryDomain}
        calendarRoles={calendarRoles}
        changeLogRoles={changeLogRoles}
        administrationRoles={administrationRoles}
        data={sortedData}
        isLoading={isLoading}
        isFetching={isFetching}
        isAllUsers={false}
        onOpenChangeLogDialog={
          needsChangeLog && !canFetch ? openDialog : undefined
        }
      />
    </>
  );
}
